<medrecord-svg-question [placement]="placement"
                        [tooltip]="hint"
                        questionType="secondary"
                        type="mystic"
></medrecord-svg-question>
